import { Component, createElement } from 'react';
import PropTypes from 'prop-types';
class ContentEditable extends Component {
  static propTypes = {
    elem: PropTypes.any,
    contentEditable: PropTypes.bool,
  };
  static defaultProps = {
    elem: 'div',
    contentEditable: false,
  };
  shouldComponentUpdate(nextProps) {
    if (this.props.contentEditable !== nextProps.contentEditable) return true;
    return false;
  }
  render() {
    const { elem, ...props } = this.props;
    return createElement(elem, { ...props });
  }
}

export default ContentEditable;
